import VueRouter from 'vue-router'

//Define route components

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
      routes: [
        {
          path: '/',
          name: 'home',
          components: {
            lander: require('./views/LandingScreen.vue'),
          }
        },
        {
          path: '/custom-dashboard',
          name: 'selectDrivers',
          components: {
            steps: require( './views/StepOne.vue' )
          },
          meta: {
            title: '<strong>Step 1:</strong> Select main value drivers',
            nav: 'button',
            buttonType: 'link',
            buttonLink: '/custom-dashboard/2'
          }
        },
        {
          path: '/custom-dashboard/2',
          name: 'selectTopics',
          components: {
            steps: require( './views/StepTwo.vue' )
          },
          meta: {
            title: '<strong>Step 2:</strong> Select sub-value drivers',
            nav: 'steps'
          }
        },
        {
          path: '/custom-dashboard/3',
          name: 'rankDrivers',
          components: {
            steps: require( './views/StepThree.vue' )
          },
          meta: {
            title: '<strong>Step 3:</strong> Rank your value drivers',
            nav: 'button',
            buttonLink: '/portal'
          }
        },
        {
          path: '/share',
          name: 'userInfo',
          components: {
            steps: require( './views/StepFour.vue' )
          },
          meta: {
            title: '<strong>Share: </strong> Share your dashboard',
            nav: 'method',
            buttonMethod: 'next'
          }
        },
        {
          path: '/portal',
          name: 'portal',
          components: {
            portal: require( './views/Portal.vue' )
          },
          meta: {
            title: '',
            nav: 'none'
          }
        },
      ]
});
export default router;



// WEBPACK FOOTER //
// ./resources/assets/js/router.js